import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import CityBuildModel from "./models/build";
export default class CityBuildingLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'CityBuildingLayer');
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.layerModel = new CityBuildModel(_this);
      yield _this.initLayerModels();
    })();
  }
  setLight(t) {
    this.updateLayerConfig({
      time: t
    });
  }
  getModelType() {
    return 'citybuilding';
  }
}